import React from "react";
import { useTranslation } from 'react-i18next'

const Hellosection = ({hellosection}) => {
  const { t, i18n } = useTranslation()

  return (
    <section className="cfan-hello-section">
    <div className="container">
        <div className="hello-content-wrapper d-flex align-items-end">
            <div className="hello-content">
                <img src={hellosection.img} alt=""/>
            </div>
            <div className="hello-description">
                <h3>{hellosection.textone} <span>{hellosection.texttwo}</span></h3>
            </div>
        </div>
    </div>
</section>
  );
};

export default Hellosection;